// Temporary no-op while the legacy design-system globalCss runtime is
// incompatible with Next 16 Turbopack in development.
export const globalStyles = () => {};
